class DealsOfTheDay extends HTMLElement {
  connectedCallback() {
    onLibReady(['vue', 'swiper'], this.#init.bind(this));
  }

  async #init() {
    new Vue({
      el: this,
      data: {
        title: this.dataset.title,
        subTitle: this.dataset.subTitle,
        showLoader: true,
        products: [],
        appliedDiscountCodes: Shopify.discount.appliedDiscountCodes,
      },
      template: `
        <template>
          <div>
            <div class="section deals-of-the-day" v-if="show && !showLoader">
              <div class="page-width-plus">
                <h2 class="section-title" v-if="title">{{ title }}</h2>
                <h2 class="section-sub-title" v-if="subTitle">{{ subTitle }}</h2>

                <div class="deals-of-the-day__product-list">
                  <div class="page-width">
                    <div class="swiper-container" ref="slider">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="variant in offers.slice(0, 10)" :key="variant.id">
                          <div class="product-card" :data-product-id="variant.product_id">
                            <a
                              :href="variant.url"
                              style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"
                              :aria-label="variant.name"
                            ></a>

                            <div class="product-card__img">
                              <a :href="variant.url" class="product-card__img-wrap">
                                <img 
                                  :srcset="$options.filters.formatImage(variant.featured_image, '170x')"
                                  src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                                  :alt="variant.full_title"
                                  loading="lazy"
                                  width="170"
                                  height="170"
                                >
                              </a>
                            </div>

                            <div class="product-card__badges">
                              <div class="product__badge product__badge--professional" v-if="variant.product_tags.includes('Professional Edition')">
                                Professional edition
                              </div>
                            </div>
                            
                            <div class="product-card__information">
                              <p class="product-card__title">
                                {{ variant.full_title }}
                              </p>
              
                              <div class="product-card__rating">
                                <div class="product-item__rating yotpo bottomLine"
                                  data-appkey="0ILNinaFxuHqNEhcKA8LxysAhrKBRoZRI9BCcMnf"
                                  :data-domain="Shopify.shop"
                                  :data-product-id="variant.product_id"
                                  :data-product-models="variant.product_id"
                                  :data-name="variant.full_title"
                                  v-if="variant.reviews_count && variant.reviews_count > 0"
                                />

                                <div class="yotpo bottomline" v-else>
                                  <div class="yotpo-bottomline">
                                      <span class="yotpo-stars">
                                        <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
                                        <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
                                        <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
                                        <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
                                        <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span>
                                      </span>
                                      <div class="yotpo-clr"></div>
                                      <span class="text-m" aria-label="0 reviews" tabindex="-1">0 Reviews</span>
                                  </div>
                                </div>
                              </div>
                              
                              <div class="product-card__price">
                                <div class="price">
                                 <span
                                    class="compare-at-price"
                                    v-html="$options.filters.formatMoney(variant.compare_at_price)"
                                    v-if="variant.compare_at_price > variant.price"
                                  ></span>

                                  <span v-html="$options.filters.formatMoney(variant.price)"></span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="slider-button-prev" ref="sliderBtnPrev" v-html="Shopify.icons.arrowPrev" />
                  <div class="slider-button-next" ref="sliderBtnNext" v-html="Shopify.icons.arrowNext" />
                  <div class="slider-dots circle" ref="sliderDots"></div>
                </div>
                
                <div class="deals-of-the-day__see-all">
                  <a href="/collections/special-offers" class="button">See all products</a>
                </div>
              </div>
            </div>
          
<!--            <div class="section deals-of-the-day__loader" v-if="showLoader">-->
<!--              <div class="loading-overlay__spinner">-->
<!--                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">-->
<!--                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>-->
<!--                </svg>-->
<!--              </div>-->
<!--            </div>-->
          </div> 
        </template>
      `,

      async mounted() {
        Shopify.discount.onUpdated(async event => {
          this.appliedDiscountCodes = event;
        });

        this.products = await this.getDiscountProducts();

        setTimeout(() => {
          this.initSlider();

          if (window.Yotpo) {
            const api = new Yotpo.API(yotpo);
            api.refreshWidgets();
          }
        });

        this.showLoader = false;
      },

      computed: {
        show() {
          return this.offers.length && (Shopify.currentCountry?.code === 'US' || Shopify.currentCountry?.code === 'CA');
        },

        offers() {
          const offers = [];

          this.products.forEach(product => {
            const discountCode = this.appliedDiscountCodes.find(code =>
              Shopify.discount.isProductEligibleForDiscount(product, code),
            );

            product.variants.forEach(variant => {
              if (
                variant.compare_at_price > variant.price &&
                (!variant.options_title.includes(Shopify.strings.voltage) ||
                  variant.options.includes(Shopify.currentCountry.voltage) ||
                  variant.options.includes(Shopify.strings.na))
              ) {
                const originalPrice = variant.price;
                offers.push({
                  ...variant,
                  url: product.url + '?variant=' + variant.id,
                  price: discountCode
                    ? Shopify.discount.getPriceWithDiscount(originalPrice, discountCode)
                    : originalPrice,
                  compare_at_price: Math.max(variant.compare_at_price, originalPrice),
                });
              }
            });
          });

          return offers.filter(offer => offer.available);
        },
      },

      methods: {
        async getDiscountProducts() {
          const response = await Shopify.shopifyService.fetchCollection('special-offers');
          return response ? response.products : [];
        },

        initSlider() {
          new Swiper(this.$refs.slider, {
            slidesPerView: 2.2,
            spaceBetween: 10,
            // loop: true,
            // centeredSlides: true,
            breakpoints: {
              990: {
                slidesPerView: 4.5,
                spaceBetween: 20,
              },
              1500: {
                slidesPerView: 5,
              },
            },
            navigation: {
              nextEl: this.$refs.sliderBtnNext,
              prevEl: this.$refs.sliderBtnPrev,
            },
            pagination: {
              el: this.$refs.sliderDots,
              type: 'bullets',
              clickable: true,
            },
          });
        },
      },

      filters: {
        formatMoney(price) {
          return formatMoney(price);
        },

        formatImage(src, size, crop) {
          return formatImage(src, size, crop);
        },
      },
    });
  }
}

customElements.define('deals-of-the-day', DealsOfTheDay);
